var PreferencesService = /** @class */ (function () {
    function PreferencesService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get Countries
     * This request takes no input and returns all the countries for the site in the following format:
   *
   * ``` json
   * {
     * "status": 200,
     * "code": "",
     * "message": "Success",
     * "data": [],
     * "dictionaries": null
     * }
     *
     * ```
     *
     * Where `data` will hold all the countries.
     * @returns any Successful response
     * @throws ApiError
     */
    PreferencesService.prototype.getApiV1PreferencesCountries = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/preferences/countries',
        });
    };
    /**
     * Get Languages
     * This request takes no input, it just returns all the languages for the site in the following way:
     *
     * ``` json
     * {
       * "status": 200,
       * "code": "",
       * "message": "Success",
       * "data": [],
       * "dictionaries": null
       * }
       *
       * ```
       *
       * Where `data` will be the list of languages.
     * @param countryCode
     * @returns any Successful response
     * @throws ApiError
     */
    PreferencesService.prototype.getApiV1PreferencesLanguages = function (countryCode) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/preferences/languages',
            query: {
                'countryCode': countryCode,
            },
        });
    };
    /**
     * Get Currencies
     * This request takes no input and returns all the currencies for the site in the following format:
       *
       * ``` json
       * {
         * "status": 200,
         * "code": "",
         * "message": "Success",
         * "data": [],
         * "dictionaries": null
         * }
         *
         * ```
         *
         * Where `data` will hold all the currencies.
     * @param countryCode Optional Parameter
     * @returns any Successful response
     * @throws ApiError
     */
    PreferencesService.prototype.getApiV1PreferencesCurrencies = function (countryCode) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/preferences/currencies',
            query: {
                'countryCode': countryCode,
            },
        });
    };
    /**
     * Save Preferences
     * This request will update the user preferences, which include the country code, currency code and language code. This request if successful will return the following:
         *
         * ``` json
         * {
           * "status": 200,
           * "code": "",
           * "message": "Success",
           * "data": [],
           * "dictionaries": null
           * }
           *
           * ```
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    PreferencesService.prototype.postApiV1PreferencesUpdate = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/preferences/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    };
    /**
     * Get Preferences
     * @returns any Successful response
     * @throws ApiError
     */
    PreferencesService.prototype.getApiV1PreferencesGet = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/preferences/get',
        });
    };
    return PreferencesService;
}());
export { PreferencesService };
